export enum AnswerEnum {
    Yes = "Y",
    No = "N"
}